<template>
  <div v-if="!getDeviceType()" class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="resetPassword" class="loginForm">
        <p class="loginTitle">Forgot Password?</p>
        <p>
          Enter your accounts email address below to receive password reset
          instructions
        </p>
        <div class="signUpNames">
          <div class="user-input-wrp">
            <input
              v-model="email"
              type="text"
              placeholder=" "
              name="email"
              required
              class="inputText"
            />
            <span class="floating-label">University email*</span>
          </div>
          <p v-if="feedback" class="feedback">{{ feedback }}</p>
        </div>
        <div class="endFormLogin">
          <button type="submit" class="joinButtonSmall">Send Email</button>
        </div>

        <div class="loginSignupDivider signupMargin"></div>
        <div class="signupBox">
          <router-link class="joinButtonSmall toSignup" :to="{ name: 'Login' }"
            >Back to login</router-link
          >
        </div>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="loginPage">
    <div class="loginColumn"></div>
    <div class="loginColumn">
      <div @submit.prevent="login" class="loginForm formOnPhone">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginLogoTextPhone" src="@/assets/CourseLnk.png" />
        <p class="loginTitle">Welcome to your online campus!</p>
        <form
          method="get"
          action="https://apps.apple.com/ca/app/courselnk/id1545799969"
        >
          <img src="../../assets/downloadOnAppStore.png" />
        </form>
        <p class="phoneText">Or access courselnk.com on a computer</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "ResetPassword",
  data() {
    return {
      email: null,
      feedback: null,
    };
  },
  mounter() {
    this.getIOS();
  },
  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return true;
      }
      return false;
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    getIOS() {
      if (this.iOS()) {
        window.location.replace("https://courselnk.page.link");
      }
    },
    resetPassword() {
      var auth = firebase.auth();
      var emailAddress = this.email;

      auth
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          this.$router.push({
            name: "EmailSent",
            params: { isVerification: false },
          });
        })
        .catch(() => {
          this.feedback = "The email entered is not valid";
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
